import { render, staticRenderFns } from "./CommesaDistinta.vue?vue&type=template&id=188d0b98&"
import script from "./CommesaDistinta.vue?vue&type=script&lang=js&"
export * from "./CommesaDistinta.vue?vue&type=script&lang=js&"
import style0 from "./CommesaDistinta.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports